import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import AllInboxIcon from '@mui/icons-material/AllInbox';
import HomeIcon from '@mui/icons-material/Home';
import MessageIcon from '@mui/icons-material/Message';
import NotificationsIcon from '@mui/icons-material/Notifications';
import { Box, BottomNavigationAction, Divider, BottomNavigation, Badge, styled } from '@mui/material';
import { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';

import { useUserInfo } from '../hooks/useUserInfo';

const actions = [
  {
    label: 'ホーム',
    icon: <HomeIcon />,
    path: '/',
  },
  {
    label: '投稿リスト',
    icon: <MessageIcon />,
    path: '/posts',
  },
  {
    label: 'タスクトレイ',
    icon: <AllInboxIcon />,
    path: '/tasks',
  },
  {
    label: 'お知らせ',
    icon: <NotificationsIcon />,
    path: '/notifications',
  },
  {
    label: 'プロフィール',
    icon: <AccountCircleIcon />,
    path: '/profile',
  },
];

const BottomNavRoot = styled(Box)(() => ({
  position: 'fixed',
  bottom: 0,
  left: 0,
  right: 0,
  height: 80, // default: 56
  zIndex: 1100, // same as appbar
}));

const StyledBottomNavigationAction = styled(BottomNavigationAction)(({ theme }) => ({
  height: 80, // default: 56
  minWidth: 'calc(100vw / 5)',
  padding: 0,
  paddingBottom: theme.spacing(2),
}));

const BottomNavbar: FC = () => {
  const { notifications, unReadNum } = useUserInfo();
  const { pathname } = useLocation();
  const [value, setValue] = useState(actions.find((item) => item.path === pathname)?.path ?? '');
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <BottomNavRoot>
      <Divider />
      <BottomNavigation
        value={value}
        onChange={(_, newValue: string) => {
          setValue(newValue);
          navigate(newValue);
        }}
        sx={{ height: 80 }}
      >
        {actions.map((item) => {
          if (item.label === 'タスクトレイ') {
            return (
              <StyledBottomNavigationAction
                key={item.label}
                showLabel
                label={t(item.label)}
                icon={
                  <Badge badgeContent={notifications.taskBadgeNum} color="error">
                    {item.icon}
                  </Badge>
                }
                value={item.path}
              />
            );
          }

          if (item.label === 'お知らせ') {
            return (
              <StyledBottomNavigationAction
                key={item.label}
                showLabel
                label={t(item.label)}
                icon={
                  <Badge badgeContent={notifications.notificationBadgeNum} color="error">
                    {item.icon}
                  </Badge>
                }
                value={item.path}
              />
            );
          }

          if (item.label === 'ホーム') {
            return (
              <StyledBottomNavigationAction
                key={item.label}
                showLabel
                label={t(item.label)}
                icon={
                  <Badge badgeContent={unReadNum} color="error">
                    {item.icon}
                  </Badge>
                }
                value={item.path}
              />
            );
          }

          return (
            <StyledBottomNavigationAction
              key={item.label}
              showLabel
              label={t(item.label)}
              icon={item.icon}
              value={item.path}
            />
          );
        })}
      </BottomNavigation>
    </BottomNavRoot>
  );
};

export default BottomNavbar;
